import { createUseStyles } from 'react-jss';
import { mixins } from '@/styles/mixins';
export const useFormStyles = createUseStyles((theme) => ({
    addButtonWrapper: {
        marginTop: '8px',
        [theme.breakpoints.up('lg')]: {
            marginTop: '0px',
        },
    },
    crossIcon: {
        transition: '0.2s',
        opacity: 'unset',
        cursor: 'pointer',
        '&[data-is-open="true"]': {
            transform: 'rotate(180deg)',
        },
    },
    agreementPersonalData: {
        '& a': {
            ...mixins.brandLinkColor(theme),
        },
    },
}), { name: 'form' });
export const useInsurerStyles = createUseStyles((theme) => ({
    insurer: {
        marginBottom: '6px',
        [theme.breakpoints.up('lg')]: {
            display: 'grid',
            gridColumnGap: '6px',
            gridRowGap: '12px',
            gridTemplateColumns: 'repeat(3, 1fr)',
            marginBottom: '12px',
        },
    },
    insurerWithoutSecondName: {
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: '5fr 5fr 3fr',
            '& > :nth-child(3)': {
                gridColumn: 'span 1',
            },
            '& > :nth-child(6)': {
                gridColumn: '1 / span 1',
            },
            '& > :nth-child(8)': {
                gridColumn: '1 / span 1',
            },
        },
    },
    fieldWrapper: {
        position: 'relative',
        marginBottom: '6px',
        [theme.breakpoints.up('lg')]: {
            marginBottom: '0px',
        },
    },
    secondNameWrapper: {
        marginBottom: '14px',
        [theme.breakpoints.up('lg')]: {
            marginBottom: '0px',
        },
    },
    hasSecondNameCheckbox: {
        marginTop: '12px',
        maxHeight: '32px',
        [theme.breakpoints.up('sm')]: {
            maxHeight: '30px',
        },
    },
}), { name: 'insurer' });
